import type { ParsedTransaction } from "@stepfinance/transaction-history";

import type { LockedTransactions, UserTransaction } from "../../hooks/queries/transactionHistory/useTransactionHistory";

export function walletIsFeePayer(tx: ParsedTransaction) {
  const walletAcc = tx.solBalanceChanges.find((acc) => acc.account === tx.wallet);
  if (!walletAcc) {
    return false;
  }
  return walletAcc.feePayer;
}

export function isUserTransactionLockedTxs(userTx: UserTransaction): userTx is LockedTransactions {
  return "remainingTxCount" in userTx;
}

export function isUserTransactionParsedTx(userTx: UserTransaction): userTx is ParsedTransaction {
  return !isUserTransactionLockedTxs(userTx);
}
